import {RuntimeEnvironment} from '../../shared/enums/runtime-environment.enum';
import {TestingPresetKey} from '../enums/debugging/testing-preset-key.enum';
import {TestingPresetConfig} from '../../shared/models/debugging/testing-preset-config';

export const TESTING_PRESETS_CONFIG: TestingPresetConfig[] = [
    {
        presetKey: TestingPresetKey.REJECT_ALL_OFFERS,
        envs: [
            RuntimeEnvironment.DEV,
            RuntimeEnvironment.TEST
        ]
    },
    {
        presetKey: TestingPresetKey.VIN_VALIDATION_DISABLED,
        envs: [
            RuntimeEnvironment.DEV,
            RuntimeEnvironment.TEST
        ]
    },
    {
        presetKey: TestingPresetKey.REJECT_GET_OFFER,
        envs: [
            RuntimeEnvironment.DEV,
            RuntimeEnvironment.TEST
        ]
    },
    {
        presetKey: TestingPresetKey.MOBILE_CONSOLE_ENABLED,
        envs: [
            RuntimeEnvironment.DEV,
            RuntimeEnvironment.TEST,
            RuntimeEnvironment.PROD,
        ]
    }
]
